import * as DWS from '@interfaces/dws/exports'

export { DWS };
